import { render, staticRenderFns } from "./AccountingDashboard.vue?vue&type=template&id=a049dc7c"
import script from "./AccountingDashboard.vue?vue&type=script&lang=ts"
export * from "./AccountingDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports